// extracted by mini-css-extract-plugin
export default {"wrapper":"EditProductCategory_wrapper__Zjs9F"};